var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48438 -1.375C5.12891 -1.375 4.875 -1.0957 4.875 -0.765625V3.5H2.64062C2.18359 3.5 1.95508 4.05859 2.28516 4.38867L6.14453 8.24805C6.32227 8.42578 6.65234 8.42578 6.83008 8.24805L10.6895 4.38867C11.0195 4.05859 10.791 3.5 10.334 3.5H8.125V-0.765625C8.125 -1.0957 7.8457 -1.375 7.51562 -1.375H5.48438ZM13 8.17188C13 7.8418 12.7207 7.5625 12.3906 7.5625H8.6582L7.41406 8.80664C6.90625 9.33984 6.06836 9.33984 5.56055 8.80664L4.31641 7.5625H0.609375C0.253906 7.5625 0 7.8418 0 8.17188V11.0156C0 11.3711 0.253906 11.625 0.609375 11.625H12.3906C12.7207 11.625 13 11.3711 13 11.0156V8.17188ZM9.85156 10.4062C9.85156 10.6855 9.62305 10.9141 9.34375 10.9141C9.06445 10.9141 8.83594 10.6855 8.83594 10.4062C8.83594 10.127 9.06445 9.89844 9.34375 9.89844C9.62305 9.89844 9.85156 10.127 9.85156 10.4062ZM11.4766 10.4062C11.4766 10.6855 11.248 10.9141 10.9688 10.9141C10.6895 10.9141 10.4609 10.6855 10.4609 10.4062C10.4609 10.127 10.6895 9.89844 10.9688 9.89844C11.248 9.89844 11.4766 10.127 11.4766 10.4062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/Download_icon.bdc55115be6345a90c1d4960cbc49e2f.svg";
export { ForwardRef as ReactComponent };